import { Text } from '@cash-me/react-components'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, fontSizes, media, space } = theme

export const Wrapper = styled.footer`
  width: 100%;
  background-color: ${colors['neutral-background-contrast-medium']};
  padding-top: ${space['spacing-xl']};
  padding-bottom: ${space['spacing-xl']};

  @media (${media.tablet}) {
    position: relative;
    z-index: 1;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  margin-bottom: ${space['spacing-md']};
  gap: ${space['spacing-sm']};
  width: 100%;

  @media (${media.tablet}) {
    align-items: center;
    flex-direction: row;
  }
`

export const Address = styled.address`
  font-style: normal;
  text-align: left;
  white-space: pre-wrap;

  @media (${media.tablet}) {
    align-items: center;
  }
`

export const Social = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${space['spacing-xs']};

  a {
    all: unset;
    cursor: pointer;

    &::after {
      content: none;
    }
  }

  @media (${media.tablet}) {
    gap: ${space['spacing-xxs']};
  }

  @media (${media.desktop}) {
    gap: ${space['spacing-xs']};
  }
`

export const SafetyLinksWrapper = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: ${fontSizes['font-size-body-2']};
  gap: ${space['spacing-xxs']};

  a,
  a:visited {
    color: ${colors['primary-text-strong']};
    cursor: pointer;

    &::after {
      border-bottom-color: ${colors['neutral-background-default']};
    }
  }

  @media (${media.tablet}) {
    flex-direction: row;
    gap: ${space['spacing-xs']};
  }
`

export const Circle = styled.div`
  width: ${space['spacing-xxxs']};
  height: ${space['spacing-xxxs']};
  border-radius: ${space['spacing-nano']};
  background-color: ${colors['blue-icon-default']};
`

export const WarningWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${space['spacing-xs']};

  @media (${media.tablet}) {
    flex-direction: row;
  }
`

export const Warning = styled(Text)`
  white-space: pre-wrap;
  text-align: center;

  @media (${media.tablet}) {
    white-space: inherit;
    text-align: left;
  }
`

export const LegalInfoWrapper = styled.div`
  padding: 0 ${space['spacing-xs']};
  text-align: center;
  white-space: pre-line;

  > * {
    margin-bottom: ${space['spacing-sm']};
  }
`
